import React from 'react';

import PropTypes from 'prop-types';
import Select from '@tds/core-select';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByStatus = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    BUSINESS_APP_ORDERS: { filterByStatus, statusPlaceholder, statusFilters }
  } = localizedStrings;
  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-status' }}>
      <Select
        label={filterByStatus}
        placeholder={statusPlaceholder}
        options={statusFilters}
        defaultValue=""
        value={filters.status}
        onChange={e => setFilters({ ...filters, status: e.target.value })}
      />
    </div>
  );
};

FilterByStatus.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByStatus;
